<template>
<div class="agree-container">
    <div id="canvas-main"></div>
    <div id="replace-html"></div>
    <!-- <canvas id="the-canvas"></canvas> -->
    <!-- <canvas width="550" height="1000" id="all-canvas"></canvas> -->
    <loading v-show="isLoading"></loading>
</div>
</template>
<style lang="scss">
@import '../assets/styles/all.scss';
    #the-canvas{
        visibility: hidden;
        position: absolute;
        left: 0;
        top: 0;
    }
    #all-canvas{
        position: relative;
        z-index: 2;
    }
    .btn-box{
        position: fixed;
        height: 50px;
        bottom: 0;
        left:0;
        width: 100%;
    }


</style>
<script>
import {
    api
} from '../api/axios';
import Loading from '../components/loading';
// import PdfWork from '../utils/pdf.worker.js'
// import PDFJS from '../utils/pdf.js'

export default {
    data() {
        return {
            isLoading: false,
            helplist: [],
            total: '',
            page: 1
        }
    },
    components: {
        Loading
    },
    beforeRouteEnter(to, from, next) {
        // document.title = '借款合同';
        var meta=document.getElementById('meta')
        if(to.name=='docagree'){
            meta.content='width=device-width, initial-scale=1, maximum-scale=2';
        }
        next()
    },
    beforeRouteLeave(to, from, next){
        console.log(to,from);
        var meta=document.getElementById('meta')
        meta.content='width=device-width, initial-scale=1, maximum-scale=1,user-scalable=no';
        next()
    },
    mounted() {
        document.title='合同及相关协议'
        var urlParam=this.$route.query
        var url = decodeURIComponent(this.$route.query.docapi);
        var type = this.$route.query.filetype || 2;
        var periods=urlParam.premiumRate || ''
        var rate=urlParam.installmentNo || ''
        var stmtCode=urlParam.stmtCode || ''
        var partnerNo=urlParam.partnerNo || ''
        // console.log(this.$route.query.filetype,'fffff')

        //clear
        this.canvasMain=document.getElementById('canvas-main');
        this.canvasMain.innerHTML='';
        this.replaceHtml=document.getElementById('replace-html');
        this.replaceHtml.innerHTML='';

        if(url==''){
            this.isLoading = true;
            return
        }

        this.isLoading = true;
        api({
            id: 'fileUtilAPI.downLoadFile',
            param: {
                'fileURL': url,
                'fileType': type
            }
        }).then((response) => {
            console.log(response, 's');
            if (response.status == 200) {
                if (response.data.code = 1) {
                    if (response.data.status == "FAIL") {
                        alert(response.data.message)
                        return
                    }
                    //console.log(response.data.data.fileContent);
                    if(type==1 || type==4){
                        this.isLoading = false;
                        var docText=(response.data.data.fileContent).replace(/\${[^\}]+\}/g,'');
                        // document.write(docText);

                        // var str='[$userName]'
                        // var reg=/(\$userName)/g;
                        // console.log(str.replace(reg,''))

                        this.replaceHtml.innerHTML=docText;
                        var dom=document.getElementsByTagName('style')[0];
                        var style=document.getElementsByTagName('style')[0].innerHTML;
                        var tpm=style+'.contract-table .tc{width:50%;text-align: center;}';
                        dom.innerHTML=tpm;

                        //汉口银行
                        if(stmtCode=='HANKOU'){
                            var periodsDom=document.getElementById('periods');
                            if(periodsDom){
                                periodsDom.innerHTML=periods
                            }
                            var rateDom=document.getElementById('rate');
                            if(rateDom){
                                rateDom.innerHTML=rate
                            }
                        }

                    }else{
                        this.pdfFn(response.data.data.fileContent);
                    }
                    // window.location.href='https://one-uat.zhongan.com/fcp/diandian/c.pdf'
                } else {
                    alert('请求失败请稍后重试')
                }
            }
        }).catch(function(error) {
            alert('请求失败请稍后重试')
            console.log(error);
        });

    },
    methods: {
        pdfFn(str) {
            var _this = this;
            // console.log(str, 'PDF');

            // atob() is used to convert base64 encoded PDF to binary-like data.
            // (See also https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/
            // Base64_encoding_and_decoding.)

            var pdfData = atob(str);

            // Disable workers to avoid yet another cross-origin issue (workers need
            // the URL of the script to be loaded, and dynamically loading a cross-origin
            // script does not work).
            // PDFJS.disableWorker = true;

            // The workerSrc property shall be specified. //mozilla.github.io/pdf.js/build/pdf.worker.js
            PDFJS.workerSrc = 'https://fin-app.zhongan.com/sh/diandian/pdf.worker.js';

            // Using DocumentInitParameters object to load binary data.
            var loadingTask = PDFJS.getDocument({
                data: pdfData
            });

            // var loadingTask = PDFJS.getDocument('https://one-uat.zhongan.com/fcp/diandian/dd.pdf');

            loadingTask.promise.then((pdf)=>{
                console.log('PDF loaded');
                // console.log(pdf.numPages, 'pdfnnnnnn');
                this.total=pdf.numPages || 1;
                // Fetch the first page

                //all canvas
                // var allCanvas=document.getElementById('all-canvas');
                // this.allCtx = allCanvas.getContext('2d');
                // allCanvas.height = 1584*this.total;
                // allCanvas.width = 1224;
                // allCanvas.style.width = '550px';

                this.page = 1;
                this.createCanvas(pdf,this.page)

            }, function(reason) {
                // PDF loading error
                console.error(reason);
            });

        },
        createCanvas(pdf,pageNumber){
            pdf.getPage(pageNumber).then((page)=>{
                // console.log('Page loaded');
                var scale = 2;
                var viewport = page.getViewport(scale);

                // Prepare canvas using PDF page dimensions
                // var canvas = document.getElementById('the-canvas');
                var canvas=document.createElement('canvas')

                var context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                //document.documentElement.clientWidth
                canvas.style.width = document.documentElement.clientWidth+'px';
                // canvas.style.height =500+'px';
                this.canvasMain.appendChild(canvas);

                // var src=canvas.toDataURL('image/jpeg');
                // var img=document.createElement('img')
                // img.src=src;
                // this.canvasMain.appendChild(img);

                // Render PDF page into canvas context
                var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };

                var renderTask = page.render(renderContext);
                renderTask.then(() => {
                    // console.log(renderContext, 'Page rendered');
                    if(this.page<this.total){
                        this.page++;
                        this.createCanvas(pdf,this.page)
                    }

                    if(this.page==this.total){
                        this.isLoading = false;
                    }

                });
            });
        },
        pdfPage(pdf,pageNum){
            pdf.getPage(pageNum).then((page)=>{
                // console.log('Page loaded');
                var scale = 2;
                var viewport = page.getViewport(scale);

                // Prepare canvas using PDF page dimensions
                var canvas = document.getElementById('the-canvas');

                var context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = '550px';

                // Render PDF page into canvas context
                var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                var renderTask = page.render(renderContext);
                renderTask.then(() => {
                    // console.log(renderContext, 'Page rendered');
                    // console.log(pageNum,'nnnnnn')
                    var nowHeight=0
                    if(this.page>1){
                        nowHeight=viewport.height*(pageNum-1)-100;
                    }else{
                        nowHeight=viewport.height*(pageNum-1)
                    }
                    this.allCtx.drawImage(canvas,0,nowHeight)

                    // if(this.page<this.total){
                    //     this.page++;
                    //     this.pdfPage(pdf,this.page)
                    // }

                    if(this.page==this.total){
                        this.isLoading = false;
                    }

                });
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// docagree.vue?7550ebf7